import AuthenticateSlackTarget from './AuthenticateSlackTarget';

export default AuthenticateSlackTarget;
